








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'RefreshButton',
})
export default class RefreshButton extends Vue {
  @Prop({ required: true }) readonly status!: string;
}
